// extracted by mini-css-extract-plugin
module.exports = {"sp-175w":"SP175W_sp-175w__tTRgy"};